<script setup lang="ts">
import type { TDialogSize } from "@/components/ui/dialog/base-dialog.types";

import { computed, type Slots } from "vue";

import Dialog, { type DialogProps, type DialogSlots } from "primevue/dialog";

interface IProps extends /* @vue-ignore */ DialogProps {
  size: TDialogSize;
}

const props = defineProps<IProps>();

defineSlots<DialogSlots & Slots>();

const sizeClass = computed(() => `p-dialog--${props.size}`);
</script>

<template>
  <Dialog :class="sizeClass">
    <template
      v-for="(_, name) in $slots"
      #[name]="slotProps"
    >
      <slot
        :name="name"
        v-bind="slotProps"
      />
    </template>
  </Dialog>
</template>
